import React from "react";
import ReactDOM from "react-dom";

import Fullpage from "./app.jsx";

ReactDOM.render(<Fullpage />, document.getElementById("app"));



// WEBPACK FOOTER //
// ./src/index.jsx